import { Navigate, Outlet, useLocation } from "react-router-dom";
import Spinner from "react-bootstrap/Spinner";
import { loginPathWithReturn } from "../lib/returnAfterLogin";

const ProtectedRoute = ({
                            user,
                            loading,
                            requiredRole,
                            allowedRoles,
                            excludedRoles = [],
                        }) => {
    const location = useLocation();
    if (loading) {
        return (
            <div
                className="d-flex flex-grow-1 justify-content-center align-items-center bg-body w-100"
                style={{ minHeight: 0 }}
            >
                <Spinner
                    animation="border"
                    role="status"
                    aria-busy="true"
                    className="text-primary"
                    style={{ width: "3rem", height: "3rem" }}
                />
            </div>
        );
    }

    if (!user) {
        return <Navigate to={loginPathWithReturn(location.pathname + location.search)} replace />;
    }

    // ⛔️ Явно заборонені ролі
    if (excludedRoles.includes(user.role)) {
        return <Navigate to="/unauthorized" replace />;
    }

    // ✅ Дозволений набір ролей
    if (allowedRoles && !allowedRoles.includes(user.role)) {
        return <Navigate to="/unauthorized" replace />;
    }

    // ✅ Одна обязательная роль
    if (requiredRole && user.role !== requiredRole) {
        return <Navigate to="/unauthorized" replace />;
    }

    return <Outlet />;
};

export default ProtectedRoute;
